import {
  faAngleDown,
  faBaby,
  faBabyCarriage,
  faBicycle,
  faBookOpen,
  faBus,
  faCake,
  faCar,
  faCartShopping,
  faChildren,
  faClipboardList,
  faClockFour,
  faCoffee,
  faComputer,
  faCreditCard,
  faDumbbell,
  faGamepad,
  faGasPump,
  faGift,
  faGlobe,
  faGraduationCap,
  faHamburger,
  faHandshakeAngle,
  faHeadset,
  faHeadSideVirus,
  faHome,
  faHospital,
  faKitMedical,
  faLuggageCart,
  faMapLocationDot,
  faMobilePhone,
  faMoneyBill1Wave,
  faMusic,
  faPalette,
  faPaw,
  faPercent,
  faPersonPregnant,
  faPersonWalkingWithCane,
  faPlane,
  faSnowboarding,
  faSoccerBall,
  faTheaterMasks,
  faTicket,
  faTooth,
  faTrophy,
  faUmbrellaBeach,
  faUserGroup,
  faVideo,
} from '@fortawesome/free-solid-svg-icons';
import {
  faAccessibleIcon,
  faBehance,
  faDribbble,
  faFacebook,
  faFacebookF,
  faFacebookMessenger,
  faFacebookSquare,
  faFlickr,
  faFoursquare,
  faGithub,
  faInstagram,
  faInstagramSquare,
  faLinkedin,
  faLinkedinIn,
  faPinterest,
  faPinterestP,
  faPinterestSquare,
  faSkype,
  faSnapchat,
  faTelegram,
  faTiktok,
  faTwitch,
  faTwitter,
  faTwitterSquare,
  faVimeo,
  faWhatsapp,
  faWhatsappSquare,
  faYoutube,
  faYoutubeSquare,
} from '@fortawesome/free-brands-svg-icons';

export const iconsFa = [
  { iconName: 'faGithub', icon: faGithub, type: 'default' },
  { iconName: 'faFoursquare', icon: faFoursquare, type: 'default' },
  { iconName: 'faFlickr', icon: faFlickr, type: 'default' },
  { iconName: 'faDribbble', icon: faDribbble, type: 'default' },
  { iconName: 'faBehance', icon: faBehance, type: 'default' },
  { iconName: 'faSnapchat', icon: faSnapchat, type: 'default' },
  { iconName: 'faVimeo', icon: faVimeo, type: 'default' },
  { iconName: 'faTelegram', icon: faTelegram, type: 'default' },
  { iconName: 'faSkype', icon: faSkype, type: 'default' },
  { iconName: 'faClipboardList', icon: faClipboardList, type: 'default' },
  { iconName: 'faTooth', icon: faTooth, type: 'default' },
  { iconName: 'faHospital', icon: faHospital, type: 'default' },
  { iconName: 'faGasPump', icon: faGasPump, type: 'default' },
  { iconName: 'faCar', icon: faCar, type: 'default' },
  { iconName: 'faBus', icon: faBus, type: 'default' },
  { iconName: 'faBicycle', icon: faBicycle, type: 'default' },
  { iconName: 'faPlane', icon: faPlane, type: 'default' },
  { iconName: 'faHome', icon: faHome, type: 'default' },
  { iconName: 'faComputer', icon: faComputer, type: 'default' },
  { iconName: 'faMobilePhone', icon: faMobilePhone, type: 'default' },
  { iconName: 'faCreditCard', icon: faCreditCard, type: 'default' },
  { iconName: 'faMoneyBill1Wave', icon: faMoneyBill1Wave, type: 'default' },
  { iconName: 'faCartShopping', icon: faCartShopping, type: 'default' },
  { iconName: 'faPercent', icon: faPercent, type: 'default' },
  { iconName: 'faGift', icon: faGift, type: 'default' },
  { iconName: 'faCake', icon: faCake, type: 'default' },
  { iconName: 'faUmbrellaBeach', icon: faUmbrellaBeach, type: 'default' },
  { iconName: 'faLuggageCart', icon: faLuggageCart, type: 'default' },
  { iconName: 'faSnowboarding', icon: faSnowboarding, type: 'default' },
  { iconName: 'faHamburger', icon: faHamburger, type: 'default' },
  { iconName: 'faCoffee', icon: faCoffee, type: 'default' },
  { iconName: 'faKitMedical', icon: faKitMedical, type: 'default' },
  { iconName: 'faBookOpen', icon: faBookOpen, type: 'default' },
  { iconName: 'faGraduationCap', icon: faGraduationCap, type: 'default' },
  { iconName: 'faClockFour', icon: faClockFour, type: 'default' },
  { iconName: 'faMapLocationDot', icon: faMapLocationDot, type: 'default' },
  { iconName: 'faHeadSideVirus', icon: faHeadSideVirus, type: 'default' },
  { iconName: 'faTrophy', icon: faTrophy, type: 'default' },
  { iconName: 'faAccessibleIcon', icon: faAccessibleIcon, type: 'default' },
  {
    iconName: 'faPersonWalkingWithCane',
    icon: faPersonWalkingWithCane,
    type: 'default',
  },
  { iconName: 'faUserGroup', icon: faUserGroup, type: 'default' },
  { iconName: 'faHandshakeAngle', icon: faHandshakeAngle, type: 'default' },
  { iconName: 'faPersonPregnant', icon: faPersonPregnant, type: 'default' },
  { iconName: 'faChildren', icon: faChildren, type: 'default' },
  { iconName: 'faBaby', icon: faBaby, type: 'default' },
  { iconName: 'faBabyCarriage', icon: faBabyCarriage, type: 'default' },
  { iconName: 'faHeadset', icon: faHeadset, type: 'default' },
  { iconName: 'faMusic', icon: faMusic, type: 'default' },
  { iconName: 'faTheaterMasks', icon: faTheaterMasks, type: 'default' },
  { iconName: 'faTicket', icon: faTicket, type: 'default' },
  { iconName: 'faVideo', icon: faVideo, type: 'default' },
  { iconName: 'faGamepad', icon: faGamepad, type: 'default' },
  { iconName: 'faDumbbell', icon: faDumbbell, type: 'default' },
  { iconName: 'faPalette', icon: faPalette, type: 'default' },
  { iconName: 'faSoccerBall', icon: faSoccerBall, type: 'default' },
  { iconName: 'faPaw', icon: faPaw, type: 'default' },
  { iconName: 'faFacebook', icon: faFacebook, type: 'social-network' },
  { iconName: 'faFacebookF', icon: faFacebookF, type: 'social-network' },
  {
    iconName: 'faFacebookSquare',
    icon: faFacebookSquare,
    type: 'social-network',
  },
  {
    iconName: 'faFacebookMessenger',
    icon: faFacebookMessenger,
    type: 'social-network',
  },
  { iconName: 'faInstagram', icon: faInstagram, type: 'social-network' },
  {
    iconName: 'faInstagramSquare',
    icon: faInstagramSquare,
    type: 'social-network',
  },
  { iconName: 'faLinkedin', icon: faLinkedin, type: 'social-network' },
  { iconName: 'faLinkedinIn', icon: faLinkedinIn, type: 'social-network' },
  { iconName: 'faTwitch', icon: faTwitch, type: 'social-network' },
  { iconName: 'faTwitter', icon: faTwitter, type: 'social-network' },
  {
    iconName: 'faTwitterSquare',
    icon: faTwitterSquare,
    type: 'social-network',
  },
  { iconName: 'faTiktok', icon: faTiktok, type: 'social-network' },
  { iconName: 'faWhatsapp', icon: faWhatsapp, type: 'social-network' },
  {
    iconName: 'faWhatsappSquare',
    icon: faWhatsappSquare,
    type: 'social-network',
  },
  { iconName: 'faYoutube', icon: faYoutube, type: 'social-network' },
  {
    iconName: 'faYoutubeSquare',
    icon: faYoutubeSquare,
    type: 'social-network',
  },
  { iconName: 'faPinterest', icon: faPinterest, type: 'social-network' },
  { iconName: 'faPinterestP', icon: faPinterestP, type: 'social-network' },
  {
    iconName: 'faPinterestSquare',
    icon: faPinterestSquare,
    type: 'social-network',
  },
  { iconName: 'faGlobe', icon: faGlobe, type: 'social-network' },
];
